export enum CareTypeActionDispatchTypes {
    CARE_TYPE_INVOKE = "CARE_TYPE_INVOKE",
    CARE_TYPE_SUCCESS = "CARE_TYPE_SUCCESS",
  }

  export enum DisciplinesActionDispatchTypes {
    DISCIPLINES_INVOKE = "DISCIPLINES_INVOKE",
    DISCIPLINES_SUCCESS = "DISCIPLINES_SUCCESS",
    DISCIPLINES_RESET = "DISCIPLINES_RESET",
  }